import {
  Button,
  ButtonGroup,
  Callout,
  Card,
  FormGroup,
  Intent,
} from '@blueprintjs/core';
import { WaveTechniques } from '../../../../types';
import { useAppDispatch, useAppSelector } from '../../../../hooks';
import { WavelightsState } from '../../types';
import { useCallback } from 'react';
import { setTechnique, startTechniqueCalculation } from '../../reducer';

const TechniqueDesciption = {
  [WaveTechniques.UNDEFINED]: 'Não selecionado',
  [WaveTechniques.HEART_BEATS]: 'Batimentos cardíacos',
};

interface TechniqueCalculationProps {
  wid: string;
}
const TechniqueCalculation = ({ wid }: TechniqueCalculationProps) => {
  const dispatch = useAppDispatch();
  const {
    selectedTechnique,
    waveTechniques,
    techniqueCalculationLoading,
    techniqueCalculationResponse,
  }: WavelightsState = useAppSelector((state) => state.wavelight);

  // State Controll of current Algorithm selection
  const onTechniqueSet = useCallback(
    (technique: WaveTechniques) => {
      dispatch(setTechnique(technique));
    },
    [dispatch],
  );

  // Start technique calculation upon current wave ID
  const doTechniqueCalculation = useCallback(() => {
    dispatch(
      startTechniqueCalculation({
        id: wid,
        technique: selectedTechnique,
      }),
    );
  }, [dispatch, wid, selectedTechnique]);

  return (
    <Card>
      <FormGroup
        helperText={'Informe a técnica...'}
        intent={Intent.PRIMARY}
        label={'Técnica'}
        labelFor="technique-input"
        labelInfo={'(obrigatório)'}
      >
        <div className="bp5-html-select bp5-fill">
          <select
            value={selectedTechnique}
            onChange={(e) => {
              onTechniqueSet(
                WaveTechniques[
                  String(e.target.value) as keyof typeof WaveTechniques
                ],
              );
            }}
          >
            {waveTechniques.map((item) => {
              const wla =
                WaveTechniques[String(item) as keyof typeof WaveTechniques];
              return (
                <option key={item} value={item}>
                  {TechniqueDesciption[wla]}
                </option>
              );
            })}
          </select>
        </div>
      </FormGroup>
      {techniqueCalculationResponse && (
        <Callout>{techniqueCalculationResponse?.message}</Callout>
      )}
      <ButtonGroup>
        <Button
          icon="function"
          intent={Intent.PRIMARY}
          onClick={doTechniqueCalculation}
          disabled={selectedTechnique === WaveTechniques.UNDEFINED}
          loading={techniqueCalculationLoading}
        >
          Calcular
        </Button>
      </ButtonGroup>
    </Card>
  );
};

export default TechniqueCalculation;
